import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuestionComponent } from './question.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuestionTagsModule } from '../../question-tags';
import { QuestionTitleModule } from '../../question-title';
import { QuestionConditionsModule } from '../../../../shared';

@NgModule({
  imports: [],
  declarations: [QuestionComponent],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    QuestionTagsModule,
    QuestionConditionsModule,
    QuestionTitleModule
  ]
})
export class QuestionModule {}
